<template>
  <nuttrema-layout-east-block>
    <nuttrema-layout-west-three-vertical>

      <div slot="top-left" class="top--left__link">
        <a :title="$t('label.back')" @click="onBackEvent">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>

      <div v-if="_has(meta, 'title')" slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <template slot="center">
        <nuttrema-loader v-if="ProgramDetails.fetching || InstanceSubscribedPlanSummarized.fetching"></nuttrema-loader>
        <form-create-diet-basic-information
           v-else
          :ProgramDetails="ProgramDetails"
          :InstanceSubscribedPlanSummarized="InstanceSubscribedPlanSummarized"
          @submit="handleEventSubmit"
          @cancel="onCancelEvent">
        </form-create-diet-basic-information>
      </template>

    </nuttrema-layout-west-three-vertical>
  </nuttrema-layout-east-block>
</template>

<script>
import { mapActions } from 'vuex';

import { PROGRAMS_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import FormCreateDietBasicInformation from './form-create-diet-basic-information';

export default {
  name: 'page-create-diet-details',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: -1,
    },
  },
  data() {
    return {
      type: PROGRAMS_KEYS.diet,
    };
  },
  components: {
    NuttremaLayoutEastBlock,
    FormCreateDietBasicInformation,
    NuttremaLayoutWestThreeVertical,
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
    InstanceSubscribedPlanSummarized() {
      return this.$store.getters.InstanceSubscribedPlanSummarized;
    },
  },
  methods: {
    ...mapActions([
      'CreateProgramDetails',
    ]),
    handleEventSubmit(payload) {
      this.CreateProgramDetails({ id: this.id, type: this.type, payload }).then(() => {
        this.successNotification({ label: 'label.diet' });
        this.$router.replace({
          name: 'diet-basic-information',
          params: { id: this.ProgramDetails.data.id },
        });
      }).catch((error) => {
        console.error(error);
      });
    },
  },
  created() {
    this.$store.dispatch('CreateProgramDetailsInit', { id: this.id });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearProgramDetails', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/create-diet/page-create-diet-basic-information.vue